import { jsx as e } from "react/jsx-runtime";
import t from "@mui/joy/Stack";
const r = ({ children: r2 }) => e(t, { gap: 1, direction: "row", sx: { flex: 1 }, justifyContent: "flex-end", alignItems: "center", children: r2 });
export {
  r as ViewHeaderPanel
};
//# sourceMappingURL=ViewHeaderPanel.js.map
